(function (Drupal, once) {

  Drupal.behaviors.lifewatchDetections = {

    attach: function (context, settings) {
      const detectionItems = once('lwDetections', '.detections', context);
      detectionItems.forEach((item)=> {
        getDetectionData().then(pubData => {
          if(pubData !== 0) {
            const formatted = (pubData / 1e6).toFixed(0) + " million";
            item.innerText = formatted;
          }
        });
      });
    }
  };
}(Drupal, once));

const getDetectionData = async function () {
  const base_url = window.location.origin;
  const url = base_url + "/code/etn_json.php";
  const url_birds = base_url + "/code/etn_json.php?type=birds";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    let detections = parseInt(json.val);

    const response_birds = await fetch(url_birds)
    if (!response_birds.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json_birds = await response_birds.json();
    detections += parseInt(json_birds.val)

    return detections;
  } catch (error) {
    console.error(error.message);
    return 0;
  }
};
